import { FC } from "react";
import { IClassname } from "@/lib/types/classname";

export const FilterSchool: FC<IClassname> = ({ className }) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.96 10.8L2 7.44L10.96 4L20 7.44L10.96 10.8Z"
        stroke="white"
        strokeWidth="1.6"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M16.4001 8.7998V13.1198C12.8001 15.3598 9.2001 15.3598 5.6001 13.1198V8.7998"
        stroke="white"
        strokeWidth="1.6"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M3.43994 8V15.36"
        stroke="white"
        strokeWidth="1.6"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M4.88 16.8004C4.88 16.0004 4.24 15.3604 3.44 15.3604C2.64 15.3604 2 16.0004 2 16.8004V19.8404H4.88V16.8004Z"
        stroke="white"
        strokeWidth="1.6"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
    </svg>
  );
};
